import { useState, useEffect, useMemo } from 'react';

import { UserEnhancedApprovalFactory } from '@/domain/approvals/helpers';
import { createFilterOptions } from '@mui/material/Autocomplete';

export interface ApproverUser {
  id: string;
  username?: string;
  avatar?: string;
  fullName: string;
  tag?: string;
  picture?: string;
  [key: string]: unknown;
}

export default (formValue: ApproverUser[] = [], users: any[]) => {
  const [approvers, setApprovers] = useState<ApproverUser[]>([]);

  useEffect(() => {
    const list: ApproverUser[] = users.map((u: any) => {
      return {
        ...UserEnhancedApprovalFactory({
          userGuid: u.username,
          tag: u.username,
          id: u.id,
          picture: u.avatar,
          fullName: u.fullName,
        }).toJS(),
      } as unknown as ApproverUser;
    });
    setApprovers([...list.sort((a, b) => (a.fullName || '').localeCompare(b.fullName || ''))]);
  }, [users]);

  const value = useMemo(
    () =>
      approvers
        .filter((a) => formValue.some((f) => f.id === a.id))
        .sort((a, b) => formValue.findIndex((v) => v.id === a.id) - formValue.findIndex((v) => v.id === b.id)),
    [approvers, formValue],
  );

  return { approvers, value };
};

export const filterOptions = createFilterOptions<ApproverUser>({
  stringify: (option) => {
    return `${option.fullName} ${option.tag}`;
  },
});
